import { CoachProfileView } from '@efdigital/ll-addon-coaching';
import { CoachPartnershipActions } from '@efdigital/ll-xceed-v2/components/coaching/coachee/coach-partnership-actions.gts';
import type { CoachingCoacheeCohortCoachesCoachModel } from '@efdigital/ll-xceed-v2/routes/coaching/coachee/cohort/coaches/coach';
import { PAGE_WRAPPER_CONTENT } from '@efdigital/ll-xceed-v2/utils/layout';
import type { TOC } from '@ember/component/template-only';
import { array, concat } from '@ember/helper';
import { LinkTo } from '@ember/routing';
import { pageTitle } from 'ember-page-title';

interface CoachesCoachSignature {
  Args: {
    model: CoachingCoacheeCohortCoachesCoachModel;
    controller: unknown;
  };
}

<template>
  {{pageTitle "Coach"}}

  <div class={{PAGE_WRAPPER_CONTENT}}>
    <CoachProfileView
      class="ll-coach-profile-view"
      @coach={{@model.coach}}
      @partnershipStatus={{@model.planner.getStatusForCoach @model.coach.user}}
    >
      <:actions>
        <div
          class="my-4 d-flex flex-wrap justify-content-center align-items-center gap-3"
        >
          <CoachPartnershipActions
            @planner={{@model.planner}}
            @coachUserId={{@model.coach.user}}
            @coachName={{concat
              @model.coach.firstName
              " "
              @model.coach.lastName
            }}
            @buttonClass="btn shadow"
          />
          {{#if @model.messagePartnership}}
            <LinkTo
              @route="coaching.coachee.cohort.messages.conversation"
              @models={{array
                @model.program_id
                @model.cohort_id
                @model.messagePartnership.id
              }}
              class="btn btn-outline-primary shadow d-inline-flex align-items-center gap-2"
              data-test-message-coach
            >
              <iconify-icon icon="ph:chat-circle" aria-hidden="true" />
              Message
            </LinkTo>
          {{/if}}
        </div>
      </:actions>
    </CoachProfileView>
  </div>
</template> satisfies TOC<CoachesCoachSignature>;
